import api from '../api';

export async function getComments(articleId) {
    const response = await api.get(`/comments/article/${articleId}`);
    return response.data;
}

export async function createComment(payload) {
    const response = await api.post('/comments', payload);
    return response.data;
}

export async function updateComment(commentId, payload) {
    await api.put(`/comments/${commentId}`, payload);
}

export async function toggleCommentUpvote(commentId) {
    await api.post(`/comments/${commentId}/toggle-upvote`);
}

export async function deleteComment(commentId) {
    await api.delete(`/comments/${commentId}`);
}